import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const PremiumTag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  padding: 4px 8px;
  background: ${themeStyle.varInkMain};
  border-radius: 50px;

  font-weight: ${themeStyle.fontSemiBold};
  font-size: ${themeStyle.fontSize10};
  line-height: 12px;
  letter-spacing: 0.1em;
  color: ${themeStyle.varBackgroundAlt};
`;
